import {
  HttpHandler,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject, Provider } from '@angular/core';
import { Router } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from '@azure/msal-angular';

import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory
} from '@auth/auth.config';
import { AuthService } from '@auth/services/auth.service';

/**
 * NOTE: MSAL Angular v3 does not yet provide a native HttpInterceptorFn.
 * This is a manual adapter that bridges the class-based MsalInterceptor
 * with the new functional Angular HttpClient API.
 * TODO: Replace this with the native implementation once MSAL Angular supports it.
 */

export const MSAL_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const interceptor = inject(MsalInterceptor);

  const handler: HttpHandler = {
    handle: (request: HttpRequest<unknown>) => next(request)
  };

  return interceptor.intercept(req, handler);
};

export const AUTH_PROVIDERS: Provider[] = [
  AuthService,
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
    deps: [Router]
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
  MsalInterceptor,
  MsalService,
  MsalGuard,
  MsalBroadcastService
];
